import { optionalAddressFields as o, fullAddressFields as l } from "./index55.mjs";
import { isEmailValid as u } from "./index201.mjs";
const a = (r, i) => Object.keys(r).every((s) => {
  const e = s, t = r[e];
  return e === "request" || o.includes(e) ? !0 : i ? t : l.includes(e) || t;
}) && u(r.email);
export {
  a as validateForm
};
